/**
 * description 采编中心-I我、网站渠道-基础编辑器多图上传弹窗控制器
 * created by he.zhikai
 * created on 2017-08-16 
 */
"use strict";
angular.module("basicUploadPicturesModule", [])
    .controller("basicUploadPicturesCtrl", ["$scope", "$q", "$modalInstance", "$templateRequest", "$timeout", "$validation", "modalDialog", "httpService", "imgInfo", function ($scope, $q, $modalInstance, $templateRequest, $timeout, $validation, modalDialog, httpService, imgInfo) {
        initStatus();

        /**
         * [initStatus description] 初始化状态
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.data = {
                navs: [{
                    name: "插入图片",
                    value: "1"
                }, {
                    name: "本地上传",
                    value: "2"
                }],
                floatTypes: [{
                    name: "无浮动",
                    value: "1"
                }, {
                    name: "左浮动",
                    value: "2"
                }, {
                    name: "右浮动",
                    value: "3"
                }, {
                    name: "居中独占一行",
                    value: "4"
                }],
                insertPicture: {
                    url: "",
                    width: "",
                    height: "",
                    border: "",
                    margin: "",
                    description: ""
                },
                scale: 1, //宽高比例
                picList: []
            };
            $scope.status = {
                pictureScaling: false,
                maxSize: 30, //单图最大尺寸 单位MB
                scaleWidth: 700 //缩放宽度
            };
            $scope.data.selectedNav = angular.isDefined(imgInfo) ? $scope.data.navs[0] : $scope.data.navs[1];
            $scope.data.selectedFloat = $scope.data.floatTypes[0];
            initFileMaxSize();
            initInputFile();
            if (angular.isDefined(imgInfo)) {
                initImgInfo();
            }
        }

        /**
         * [initFileMaxSize description] 获取图片上传最大尺寸限制
         * @return {[type]} [description]
         */
        function initFileMaxSize() {
            httpService.http("/mcnww/web/image/getImageSizelimit.do", "", "get").then(function (data) {
                $scope.status.maxSize = Number(data.data) / 1024;
            });
        }
        /**
         * [initInputFile description] 初始化文件上传
         * @return {[type]} [description]
         */
        function initInputFile() {
            $scope.status.file = $(document.createElement("input"));
            $scope.status.file.attr({
                type: "file",
                name: "file",
                class: "webuploader-element-invisible",
                multiple: "file",
                accept: ".gif,.jpg,.jpeg,.bmp,.png,.webp"
            });
            $scope.status.file[0].onchange = function () {
                var self = this;
                $timeout(function () {
                    for (var i = 0; i < self.files.length; i++) {
                        if (self.files[i].type.split("/")[0] == "image") {
                            $scope.data.picList.push(self.files[i]);
                        } else {
                            modalDialog.alertType("请上传符合格式要求的文件", "", "error", false);
                        }
                    }
                    $timeout(function () {
                        //如框内高度不够显示图片，则新上传的图片将老图片往上顶
                        var height = $('.basic-upload-pictures').find('.pic-items').height();
                        $('.basic-upload-pictures').find('.pic-content').scrollTop(height);
                    });
                    initInputFile();
                });
            };
        }

        /**
         * [initImgInfo description] 初始化图片信息
         * @return {[type]} [description]
         */
        function initImgInfo() {
            var imgNode = $(imgInfo);
            var img = new Image();
            img.src = imgNode.attr("src");
            img.onload = function () {
                $scope.data.uploadpic = imgNode.attr("uploadpic");
                $scope.data.insertPicture = {
                    url: imgNode.attr("src"),
                    width: parseInt(imgNode.attr("width")) || this.width,
                    height: parseInt(imgNode.attr("height")) || this.height,
                    border: parseInt(imgNode.attr("border")) || 0,
                    margin: parseInt(imgNode.attr("vspace")) || 0,
                    description: imgNode.attr("title") || ""
                };
            };
            img.onerror = function () {
                $scope.data.insertPicture = {
                    url: imgNode.attr("src"),
                    width: parseInt(imgNode.attr("width")) || "",
                    height: parseInt(imgNode.attr("height")) || "",
                    border: parseInt(imgNode.attr("border")) || 0,
                    margin: parseInt(imgNode.attr("vspace")) || 0,
                    description: imgNode.attr("title") || ""
                };
            };
        }

        /*插入图片部分开始*/
        /**
         * [scalingCheck description] 固定比例确认框
         * @return {[type]} [description]
         */
        $scope.scalingCheck = function () {
            if (($scope.data.insertPicture.width !== '' && $scope.data.insertPicture.height !== '') || $scope.status.pictureScaling === true) {
                $scope.status.pictureScaling = !$scope.status.pictureScaling;
                if ($scope.status.pictureScaling === true) {
                    $scope.data.scale = ($scope.data.insertPicture.width / $scope.data.insertPicture.height) || 1;
                }
            }
        };
        /**
         * [description] 监听宽高，保持固定比例
         * @param  {[type]} newValue  [description]
         * @param  {[type]} oldValue) {  
         * @return {[type]}           [description]
         */
        $scope.$watch("data.insertPicture.width", function (newValue, oldValue) {
            if ($scope.status.pictureScaling === true) {
                $scope.data.insertPicture.height = newValue === "" ? 0 : (newValue / $scope.data.scale);
            }
        });
        $scope.$watch("data.insertPicture.height", function (newValue, oldValue) {
            if ($scope.status.pictureScaling === true) {
                $scope.data.insertPicture.width = newValue === "" ? 0 : (newValue * $scope.data.scale);
            }
        });
        /*插入图片部分结束*/
        /**
         * [cancel 关闭]
         * @return {[type]} [description]
         */
        $scope.cancel = function () {
            $modalInstance.dismiss();
        };
        /**
         * [chooseLocalPics 上传本地图片]
         * @return {[type]} [description]
         */
        $scope.chooseLocalPics = function () {
            $scope.status.file[0].click();
        };
        /**
         * [deletePic 删除图片]
         * @return {[int]} index [description] //删除图片的序号
         */
        $scope.deletePic = function (index) {
            $scope.data.picList.splice(index, 1);
        };
        /**
         * [getPreviewUrl ]获取图片预览地址
         * @params {[object]} item [description] 图片文件对象
         * @return {[type]} [description]
         */
        $scope.getPreviewUrl = function (item) {
            if (!!item.isPersonalPic) {
                return;
            } else {
                item.previewSrc = URL.createObjectURL(item);
                $scope.uploadPics([item]);
            }
        };
        /**
         * [getPicsSize] 获取选中图片的总大小
         * @return {[type]} [description]
         */
        $scope.getPicsSize = function () {
            return (function () {
                var size = 0;
                for (var i = 0; i < $scope.data.picList.length; i++) {
                    size += $scope.data.picList[i].size;
                }
                return Math.round(size / 1024 / 1024 * 100) / 100;
            })();
        };
        /**
         * [uploadPics] 开始上传图片
         * @return {[type]} [description]
         */
        $scope.uploadPics = function (imgs) {
            var imgArray = imgs ? imgs : $scope.data.picList;
            for (var i = 0; i < imgArray.length; i++) {
                if (angular.isUndefined(imgArray[i].realSrc)) {
                    uploadPic(imgArray[i], i, function (data, index) {
                        $timeout(function () {
                            $scope.$apply(function () {
                                imgArray[index].progress = Math.round((data.loaded / data.total * 100)) + "%";
                            });
                        });
                    }, function (data, index, imgInfo) {
                        // console.log(imgInfo);
                        $scope.$apply(function () {
                            if (JSON.parse(data).success === false) {
                                imgArray[index].error = JSON.parse(data).message;
                                return;
                            }
                            imgArray[index].realSrc = angular.globalConfig.pictureServer + JSON.parse(data).url;
                            if (imgInfo) {
                                imgArray[index].width = imgInfo.width;
                                imgArray[index].height = imgInfo.height;
                            }

                        });
                    }, function (data, index) {
                        imgArray[index].error = data;
                    });
                }
            }
        };
        /**
         * [scaleImg] 缩放图片
         * @param {[string]} [imgName] [description] 图片名称
         * @return {[type]} [description]
         */
        function scaleImg(imgName) {
            var deffer = $q.defer();
            var img = new Image();
            img.src = "/wcm/file/read_image.jsp?FileName=" + imgName;
            img.onload = function () {
                var aspectRatio = img.width / img.height;
                var scaleHeight = Math.round($scope.status.scaleWidth / aspectRatio);
                var params = {
                    FILENAME: imgName,
                    FOLDEREXT: "U0",
                    SCALEHEIGHT: scaleHeight,
                    SCALEWIDTH: $scope.status.scaleWidth,
                    methodname: "scaleImage",
                    serviceid: "mlf_image",
                };
                httpService.httpServer("", params, "get").then(function (data) {
                    deffer.resolve(data);
                });
            };
            return deffer.promise;
        }
        /**
         * [getAllPercent] 获取总体上传进度
         * @return {[type]} [description]
         */
        $scope.getAllPercent = function () {
            var percent = 0;
            for (var i = 0; i < $scope.data.picList.length; i++) {
                var picFile = $scope.data.picList[i];
                if (picFile.progress !== undefined) {
                    percent += parseFloat(picFile.progress.replace(/%/g, "")) / $scope.data.picList.length;
                }
            }
            return Math.round(percent) + "%";
        };
        /**
         * [getImgWidthAndHeight description] 获取图片宽高
         * @param   {[type]}  file  [file description]
         * @return  {[type]}        [return description]
         */
        function getImgWidthAndHeight(file) {
            var defer = $q.defer();
            var reader = new FileReader()
            reader.onload = function (event) {
                var base64 = event.target.result;
                var img = document.createElement('img');
                img.src = base64;
                img.onload = function () {
                    defer.resolve(img);
                };
            }
            reader.readAsDataURL(file);
            return defer.promise;
        }
        /**
         * [uploadPic] 上传图片
         * $param {[fn]} onProgress 上传进度回调函数
         * @param {[fn]} onload [description] 上传完成回调函数
         * @return {[type]} [description]
         */
        function uploadPic(fileInfo, index, onProgress, onload, onerror) {
            if (fileInfo.size / 1024 / 1024 > $scope.status.maxSize) {
                onerror("图片超过" + $scope.status.maxSize + "M", index);
                return false;
            }
            getImgWidthAndHeight(fileInfo).then(function (imgInfo) {
                var fd = new FormData();
                fd.append("file", fileInfo);
                var xhr = new XMLHttpRequest();
                xhr.open('POST', '/mcnww/upload/image.do', true);
                xhr.onload = function (evt) {
                    onload(evt.currentTarget.responseText, index, imgInfo);
                    //console.log(evt.currentTarget.responseText);
                };
                xhr.onerror = function (evt) {
                    onerror("上传失败，请重新上传", index);

                };
                xhr.upload.onprogress = function (evt) {
                    //console.log("进度条");
                    //console.log(evt);
                    onProgress(evt, index);

                };
                xhr.upload.onloadstart = function () {
                    //console.log("开始传了");
                };
                xhr.onreadystatechange = function () { };
                xhr.send(fd);
            });

        }
        /**
         * [uploadends] 上传是否正在进行
         * @return {[type]} [description]
         */
        $scope.uploadIsRunning = function () {
            var flag = false;
            for (var i = 0; i < $scope.data.picList.length; i++) {
                if (($scope.data.picList[i].progress !== undefined && $scope.data.picList[i].progress !== '100%')) flag = true;
            }
            return flag;
        };
        /**
         * [uploadEnd] 是否所有图片上传完成
         * @return {[type]} [description]
         */
        $scope.uploadEnd = function () {
            for (var i = 0; i < $scope.data.picList.length; i++) {
                if ($scope.data.picList[i].realSrc === undefined) {
                    return false;
                }
            }
            return true;
        };
        /**
         * [confirm] 确认
         * @return {[type]} [description]
         */
        $scope.confirm = function () {
            if ($scope.data.selectedNav.value == '1') {
                $scope.insertPicturesForm.$pending = {};
                $validation.validate($scope.insertPicturesForm).
                    success(function () {
                        var insertDom = document.createElement("div");
                        insertDom.innerHTML = '<p><img /></p>';
                        $(insertDom).find('img').attr({ 'src': $scope.data.insertPicture.url, 'width': $scope.data.insertPicture.width, 'height': $scope.data.insertPicture.height, 'uploadpic': angular.isDefined($scope.data.uploadpic) ? $scope.data.uploadpic : $scope.data.insertPicture.url, 'title': $scope.data.insertPicture.description, 'alt': $scope.data.insertPicture.description, 'border': $scope.data.insertPicture.border, 'vspace': $scope.data.insertPicture.margin });
                        if ($scope.data.selectedFloat.value == "2" || $scope.data.selectedFloat.value == "3") {
                            $(insertDom).find('img').css({ 'float': $scope.data.selectedFloat.value == "2" ? 'left' : 'right' });
                            $(insertDom).find('p').css('overflow', 'hidden');
                        } else if ($scope.data.selectedFloat.value == "4") {
                            $(insertDom).find('p').css('text-align', 'center');
                        }
                        var insertHtml = $(insertDom).html();
                        $modalInstance.close(insertHtml);
                    }).
                    error(function () {
                        $timeout(function () {
                            modalDialog.alertType("提交失败", "请检查填写项", "error", false);
                        }, 300);
                    });
            } else if ($scope.data.selectedNav.value == '2') {
                var flag = $scope.uploadEnd(); //图片是否上传完成 ture为是 false为否
                if (!flag) {
                    modalDialog.alertType("您还有未上传完成的图片", "", "warning", false);
                    return;
                }
                var newHtml = "";
                for (var i = 0; i < $scope.data.picList.length; i++) {
                    var dom = document.createElement("div");
                    dom.innerHTML = '<p><img /></p>';
                    if ($scope.data.picList[i].realSrc !== undefined) {
                        var fileInfo = $scope.data.picList[i];
                        var uploadpic = fileInfo.realSrc.split("=")[1] || fileInfo.realSrc;
                        if (fileInfo) {
                            var imgWidth = fileInfo.width > 550 ? 550 : fileInfo.width;
                        }
                        $(dom).find("img").attr({ "src": fileInfo.realSrc, "uploadpic": uploadpic, "title": fileInfo.name || fileInfo.imgDesc, "alt": fileInfo.name || fileInfo.imgDesc, "width": imgWidth });
                    }
                    if ($scope.data.selectedFloat.value == "2" || $scope.data.selectedFloat.value == "3") {
                        $(dom).find('img').css({ 'float': $scope.data.selectedFloat.value == "2" ? 'left' : 'right' });
                        $(dom).find('p').css('overflow', 'hidden');
                    } else if ($scope.data.selectedFloat.value == "4") {
                        $(dom).find('p').css('text-align', 'center');
                    }
                    newHtml += $(dom).html();
                }
                $modalInstance.close(newHtml);
            }
        };
    }]);